import { SNOOZE_MS } from './feedbackTrigger';

const K = { optOut: 'alertai_asistente_optout', snooze: 'alertai_asistente_snooze', asked: 'alertai_asistente_preguntadas' };

function read(key: string): string | null { try { return localStorage.getItem(key); } catch { return null; } }
function write(key: string, v: string | null) {
  try { if (v === null) localStorage.removeItem(key); else localStorage.setItem(key, v); } catch { /* sin almacenamiento: no se recuerda */ }
}

export const assistantStorage = {
  getOptOut: () => read(K.optOut) === '1',
  setOptOut: (v: boolean) => write(K.optOut, v ? '1' : null),
  getSnoozedUntil: (): number | null => { const v = Number(read(K.snooze)); return Number.isFinite(v) && v > 0 ? v : null; },
  snooze: (now: number) => write(K.snooze, String(now + SNOOZE_MS)),
  getAskedSessions: (): string[] => {
    try {
      const v = JSON.parse(read(K.asked) || '[]');
      return Array.isArray(v) ? v.filter((x): x is string => typeof x === 'string') : [];
    } catch { return []; }
  },
  markAsked: (sessionId: string) => {
    const list = assistantStorage.getAskedSessions().filter(id => id !== sessionId);
    write(K.asked, JSON.stringify([...list, sessionId].slice(-200)));
  },
};
